export default function getBadgeClasses(status) {
	let classes = "mb-0 badge badge-light-";
	if (["Completed", "open"].includes(status)) classes += "success";
	if (status === "Pending") classes += "warning";
	if (status === "ReadyToPickup") classes += "primary";
	if (["Rejected", "Cancelled", "closed"].includes(status)) classes += "danger";
	if (["StartedDineIn", "Preparation"].includes(status)) classes += "secondary";
	if (["Ongoing", "Paid", "Confirmed", "PickedUp"].includes(status))
		classes += "info";
	return classes;
}
